








































































































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import PasswordResettingApi from '@/app/model/api/passwordResettingApi'
import PasswordHashCheckApi from '@/app/model/api/passwordHashCheckApi'
/* module */
import Local from '@/app/module/local'
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    ErrorInfo
  }
})
export default class PasswordResetting extends Vue {
  private registeredEmail: string = ''
  private password: string = ''
  private confirmPassword: string = ''
  private inputErrorMessages: {[key:string]: any } = {}
  private errorMessage: string = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private showAlert: boolean = false
  private showExpried: boolean = false
  private showComplate: boolean = false
  private show400ErrorMessage: boolean = false

  created () {
    (async () => {
      const bodyData = {
        'one_time_key': this.$route.params.uq_key
      }
      const result = await PasswordHashCheckApi.doPasswordHashCheck(bodyData)

      if (result.isOk()) {
        // OKの場合は初期表示
        this.showExpried = false
        this.showComplate = false
      } else if (result.getPayload().status_code === '401') {
        this.showExpried = true
      } else if (result.getPayload().status_code === '400') {
        // バリデーションエラー(alert表示)
        let errors: any = []
        for (var i in result.getPayload().errors) {
          errors.push(result.getPayload().errors[i].message)
        }
        this.alertText = ''
        this.alertTitle = errors.join('<br/>')
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      } else {
        // 500系とその他
        this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_SERVER)
        this.$router.push(routerPath.PATH_ERROR_PAGE).catch(e => {})
      }
    })()
  }

  private async registPassword () {
    if (this.isRegistPassword()) {
      const bodyData = {
        'new_password': this.password,
        'confirmation_password': this.confirmPassword
      }

      const result = await PasswordResettingApi.doPasswordResetting(this.$route.params.uq_key, bodyData)
      if (result.isOk()) {
        this.showComplate = true
      } else if (result.getPayload().status_code === '401') {
        this.showExpried = true
      } else if (result.getPayload().status_code === '400') {
        // バリデーションエラー(alert表示)
        let errors: any = []
        errors.push('<ul>')
        for (var i in result.getPayload().errors) {
          errors.push('<li>' + result.getPayload().errors[i].message + '</li>')
        }
        errors.push('</ul>')
        this.alertText = errors.join('')
        this.alertTitle = ''
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      } else {
        // 500系とその他
        this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_SERVER)
        this.$router.push(routerPath.PATH_ERROR_PAGE).catch(e => {})
      }
    } else {
      this.alertText = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
    }
  }

  private isRegistPassword () {
    const passwordFlag = Validator.validateInputPassword('passwordErrorMessage', this.password)
    const confirmPasswordFlag = Validator.validateInputConfirmPassword('confirmPasswordErrorMessage', this.confirmPassword)

    this.inputErrorMessages = Validator.getErrorMessage()

    if (passwordFlag && confirmPasswordFlag) {
      if (this.password === this.confirmPassword) {
        return true
      }
      this.inputErrorMessages.confirmPasswordErrorMessage = '入力内容が「パスワード」と一致しません。'
    }
    return false
  }
}
